@import "./action-messages-body/action-messages-body";
@import "../../../../../styles/variables";

.conversational-search-action-messages {
  background-color: $svs-white;
  border: 1px solid $svs-super-light-grey;
  border-radius: 4px;
  box-shadow: 0px 0px 16px 0px #62646933;
  box-sizing: content-box;
  left: 50%;
  max-width: 85%;
  padding: 13px 16px;
  position: absolute;
  -webkit-transform: translate(-50%, -100%);
  transform: translate(-50%, -100%);
  top: -24px;
  width: max-content;
  z-index: 1;
}
